import { createRootRoute, Outlet, redirect } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/router-devtools";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { customerPortalRedirect } from "@/lib/customer-portal-redirect";

export const Route = createRootRoute({
  beforeLoad: ({ location }) => {
    const target = customerPortalRedirect(new URL(location.href, window.location.origin).href,
      import.meta.env.VITE_CUSTOMER_PORTAL_URL ?? "");
    if (target) throw redirect({ href: target });
  },
  component: () => (
    <ErrorBoundary>
      <Outlet />
      {import.meta.env.DEV ? <TanStackRouterDevtools position="bottom-right" /> : null}
    </ErrorBoundary>
  ),
});
